import { render, staticRenderFns } from "./UserQuanyi.vue?vue&type=template&id=264706ed&"
import script from "./UserQuanyi.vue?vue&type=script&lang=js&"
export * from "./UserQuanyi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports